<template>
  <v-app-bar class="ongeo-toolbar"
             app
             :clipped-left="clippedLeft"
             :height="`${toolbarHeight}px`">
    <v-row class="pa-2">
      <v-col xs="6"
             xl="2"
             lg="2"
             :class="{'align-self-center':products&&products.length===0}">
        <v-row class="pa-0 ma-0 px-2"
               v-if="products && products.length > 0">
          <v-col cols="12"
                 class="pa-0">
            <vue-on-geo-logo :is-mobile="isMobileView" :href="currentProduct ? currentProduct.href : 'https://ongeo.pl/'"></vue-on-geo-logo>
          </v-col>
          <v-col v-if="currentProduct"
                 cols="12"
                 class="text-sm-right pa-0">
            <v-menu v-model="model"
                    offset-y
                    style="width: 100%;">
              <template v-slot:activator="{ on }">
                <v-btn v-on="on"
                       right
                       tile
                       style="width: 100%; border-top-color: #facf00;"
                       :class="`products__handle active right-aligned-button text-none ${subheaderFontSize}`"
                       text>
                  {{ currentProduct.name }}
                  <v-icon x-large
                          class="ml-2">
                    {{ model !== null && model ? "mdi-chevron-up": "mdi-chevron-down" }}
                  </v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item class="pb-0"
                             v-for="(product, index) in products"
                             :key="index">
                  <v-list-item-content class="pa-0 ma-0">
                    <a class="nc"
                       :title="product.title"
                       :href="product.href">
                      <icon-base-header :name="product.componentName"
                                        :color="'#fdc600'" />
                    </a>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-col>
        </v-row>
        <vue-on-geo-logo v-else
                      :is-mobile="isMobileView"
                      :href="currentProduct ? currentProduct.href : 'https://ongeo.pl'"></vue-on-geo-logo>
      </v-col>
      <!-- WEB VIEW -->
      <template v-if="isWebView">
        <v-col right
               :xl9="isLoginButtonExists"
               :lg8="isLoginButtonExists"
               :lg10="!isLoginButtonExists"
               class="align-self-center">
          <v-row :class="`${subheaderFontSize}`">
            <v-col class="toolbar-a text-sm-right pa-1 mr-2"
                   cols="12">
              <span @mouseover="showPhone = true"
                    @mouseout="showPhone = false">
                <span v-if="showPhone"
                      class="mr-2">+48 12 34 09 449</span>
                <a href="tel:+48123409449">
                  <v-icon medium
                          color="primary">mdi-phone</v-icon>
                </a>
              </span>
              <span class="px-3"
                    @mouseover="showMail = true"
                    @mouseout="showMail = false">
                <span v-if="showMail"
                      class="mr-2">kontakt@ongeo.pl</span>
                <a href="mailto:kontakt@ongeo.pl">
                  <v-icon medium
                          color="primary">mdi-email</v-icon>
                </a>
              </span>
              <slot name="contact-ext"></slot>
            </v-col>
            <v-col cols="12"
                   class="text-sm-right pa-1"
                   v-if="toolbarItems && toolbarItems.length > 0">
              <template v-for="(item, i) in toolbarItems">
                <v-menu v-model="productsModel"
                        offset-y
                        v-if="item.subitems"
                        :key="`toolbar-item-${i}`">
                  <v-btn slot="activator"
                         :class="`text-none ${subheaderFontSize}`"
                         text>
                    {{ item.name }}
                    <v-icon medium>
                      {{
                      productsModel !== null && productsModel
                      ? "mdi-chevron-up"
                      : "mdi-chevron-down"
                      }}
                    </v-icon>
                  </v-btn>

                  <v-list>
                    <v-list-item v-for="(subitem, j) in item.subitems"
                                 :key="`toolbar-item-${i}-${j}`"
                                 :to="subitem.to">
                      <v-list-item-title :class="`${subheaderFontSize}`">{{ subitem.name }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
                <v-btn v-else-if="item.to"
                       :to="item.to"
                       :title="item.title ? item.title : item.name"
                       :class="`v-btn-t px-0 mx-3 text-none ${subheaderFontSize} ${item.webStyle}`"
                       text
                       tile
                       :key="`toolbar-item-${i}`">{{ item.name }}</v-btn>
                <span v-else
                      @click="item.click"
                      :key="`toolbar-item-${i}`">
                  <v-btn :title="item.title ? item.title : item.name"
                         tile
                         :class="`v-btn-t px-0 mx-3 text-none ${subheaderFontSize} ${item.webStyle}`"
                         text>{{ item.name }}</v-btn>
                </span>
              </template>
            </v-col>
          </v-row>
        </v-col>
        <v-col v-if="isLoginButtonExists"
               xl="1"
               lg="2"
               class="align-self-center pl-4 text-center">
          <slot name="loginButton"></slot>
        </v-col>
      </template>
      <!-- MOBILE VIEW -->
      <template v-else>
        <v-spacer />
        <v-col xs="2"
               class="align-self-center text-center">
          <v-menu offset-y
                  v-model="mobileMenu"
                  bottom
                  left>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on"
                     icon>
                <v-icon large
                        color="primary">
                  mdi-menu
                </v-icon>
              </v-btn>
            </template>
            <v-expansion-panels accordion>
              <template v-if="toolbarItems && toolbarItems.length > 0">
                <v-expansion-panel v-for="(item, i) in toolbarItems"
                                   :key="`toolbar-item-${i}`"
                                   :class="item.mobileStyle">
                  <v-expansion-panel-header :hide-actions="!item.subitems">
                    <router-link v-if="item.to"
                                 @click.native="closeMobileMenu"
                                 :class="item.mobileStyle"
                                 :to="item.to">
                      {{ item.name }}
                    </router-link>
                    <div v-else-if="item.click"
                         @click.native="closeMobileMenu"
                         :class="item.mobileStyle"
                         @click.exact="item.click">
                      {{ item.name }}
                    </div>
                    <template v-else>
                      {{ item.name }}
                    </template>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content v-if="item.subitems">
                    <v-card pa-2>
                      <v-card-text class="pl-4"
                                   v-for="(subitem, j) in item.subitems"
                                   :key="`toolbar-item-${i}-${j}`">
                        <router-link @click.native="closeMobileMenu"
                                     :to="subitem.to">
                          {{ subitem.name }}
                        </router-link>
                      </v-card-text>
                    </v-card>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </template>
              <v-expansion-panel>
                <v-expansion-panel-header hide-actions>
                  <a @click="closeMobileMenu"
                     href="tel:+48123409449">
                    <v-icon style="margin-right: 4px;"
                            color="ongeoprimary">mdi-phone</v-icon>+48 12 34 09 449
                  </a>
                </v-expansion-panel-header>
              </v-expansion-panel>
              <v-expansion-panel>
                <v-expansion-panel-header hide-actions>
                  <a @click="closeMobileMenu"
                     href="mailto:kontakt@ongeo.pl">
                    <v-icon style="margin-right: 4px;"
                            color="ongeoprimary">mdi-email</v-icon>kontakt@ongeo.pl
                  </a>
                </v-expansion-panel-header>
              </v-expansion-panel>
              <slot name="contact-ext" />
              <v-expansion-panel>
                <v-expansion-panel-header hide-actions
                                          class="text-center"
                                          v-if="isLoginButtonExists">
                  <slot @click="closeMobileMenu"
                        name="loginButton" />
                </v-expansion-panel-header>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-menu>
        </v-col>
      </template>
    </v-row>
  </v-app-bar>
</template>

<script>
import VueOnGeoLogo from "./vue-ongeo-logo.vue";
import VueOnGeoGlobalMixin from "./vue-ongeo-global-mixin.js";
import IconBaseHeader from './icon/IconBaseHeader.vue';

export default {
  name: "vue-ongeo-toolbar",
  mixins: [VueOnGeoGlobalMixin],
  components: { VueOnGeoLogo, IconBaseHeader },
  props: {
    currentProductCode: String,
    clippedLeft: { type: Boolean, default: false },
    toolbarItems: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  computed: {
    toolbarHeight () {
      return this.isMobileView ? 80 : 104;
    },
    products () {
      if (this.currentProductCode) {
        return this.allProducts.filter(item => {
          return item.code !== this.currentProductCode;
        });
      }
      return null;
    },
    currentProduct () {
      return this.allProducts.find(item => {
        return this.currentProductCode === item.code;
      });
    },
    isLoginButtonExists () {
      return this.$slots.loginButton && this.$slots.loginButton.length > 0;
    }
  },
  data: function () {
    return {
      showPhone: false,
      showMail: false,
      model: null,
      mobileMenu: false,
      productsModel: null,
      allProducts: [
        {
          code: "ongeo",
          componentName: "logo_header_wszystko_o_lokalizacji_ongeo",
          title: "OnGeo strona główna",
          alt: "logo OnGeo Główna",
          name: "Wszystko o lokalizacji",
          href: "https://ongeo.pl/"
        },
        {
          code: "ongeoreports",
          componentName: "logo_header_rapoty_o_terenie_ongeo",
          title: "Wszystkie dane o nieruchomości w jednym miejscu",
          alt: "logo OnGeo raporty",
          name: "Raporty o Terenie",
          href: "https://ongeo.pl/raporty/"
        },
        {
          code: "ongeoagro",
          componentName: "logo_header_agro_ongeo",
          title: "Oszacowania szkody w rolnictwie",
          alt: "logo OnGeo Agro",
          name: "Agro",
          href: "https://agro.ongeo.pl/"
        },
        {
          code: "ongeoestates",
          componentName: "logo_header_nieruchomosci_ongeo",
          title: "Ogłoszenia nieruchomości na mapie",
          alt: "logo OnGeo Nieruchomości",
          name: "Nieruchomości",
          href: "https://nieruchomosci.ongeo.pl/"
        },
        {
          code: "management",
          componentName: "logo_header_api_ongeo",
          title: "Usługi deweloperskie GIS",
          alt: "logo OnGeo Api",
          name: "API",
          href: "https://api.ongeo.pl/"
        },
        {
          code: "ongeoblog",
          componentName: "logo_header_blog_ongeo",
          title: "Ocena potencjału inwestycyjnego nieruchomości",
          alt: "logo OnGeo Blog",
          name: "Blog",
          href: "https://blog.ongeo.pl/"
        },
      ]
    };
  },
  methods: {
    closeMobileMenu () {
      this.mobileMenu = false;
    }
  }
};
</script>

<style lang="scss">
.ongeo-toolbar {
  background-color: #fff !important;
  &.theme--dark {
    background-color: #272727 !important;
    .v-btn__content {
      color: #fff !important;
    }
    .products__handle {
      background-color: inherit !important;
    }
  }

  .v-btn-t {
    border-color: #fdc600;
    border-radius: 0px !important;
    padding-left: 0px !important;
    padding-right: 0px !important;

    :not(.v-btn--active) {
      :hover {
        border-top: 2px solid #fdc600;
        transition: border-color 0.5s;
      }
    }

    &.v-btn--active {
      :before {
        opacity: 0 !important;
      }
      border-top: 2px solid #fdc600;
      transition: border-color 0.2s;
    }
  }
}

.theme--dark {
  .product-header-name {
    fill: #fff !important;
  }
}

.product-header-icon {
  fill: #fdc600;
}
.product-header-name {
  font-size: 18px;
  fill: black;
}

.product-header-pin {
  fill: none;
  stroke: #fcc70d;
  stroke-width: 2.5;
  stroke-miterlimit: 10;
}

header .v-toolbar__content {
  padding-top: 8px;
}
.text-none {
  text-transform: none !important;
}

a {
  text-decoration: unset;
}

.right-aligned-button {
  div {
    -webkit-box-pack: end;
    -ms-flex-pack: end;
    justify-content: flex-end;
  }
}

.products__handle.active,
.products__handle:hover {
  border-color: #fdc600;
}

.products__handle {
  width: 100%;
  display: flex;
  background-color: #fff;
  bottom: 0;
  transition: border-color 0.2s;
  align-self: center;
  font-size: 1.2em;
  justify-content: flex-end;
  border-top: 2px solid;

  .theme--dark {
    background-color: unset !important;
  }
}
</style>
